import { useFusaOrganizationStore } from "@/frontend/store/FusaOrganizationStore";
import { useProjectStore } from "@/frontend/store/ProjectStore";
import { useWorkspaceStore } from "@/frontend/store/WorkspaceStore";
import { I18n } from "@/i18n/I18n";
import { useShallow } from "zustand/react/shallow";
import { ProjectParentType } from "@/backend/models/project";
import { BreadcrumbItem, Breadcrumbs } from "../Breadcrumbs";

export function ProjectBreadcrumb({ projectId, showProjectLink, trailingItems }: { projectId: string, showProjectLink?: boolean, trailingItems?: BreadcrumbItem[] }) {
  const project = useProjectStore(useShallow(state => state.projects.find(project => project.id === projectId)));
  const workspace = useWorkspaceStore(useShallow(state => state.workspaces.find(workspace => workspace.id === project?.parentId)));
  const fusaOrganization = useFusaOrganizationStore(useShallow(state => state.fusaOrganizations.find(fusaOrganization => fusaOrganization.id === (workspace?.ownerFusaOrgId || project?.parentId))));

  // A project template hangs off its organization, and templates are listed in the Library.
  const organizationLink = project?.parentType === ProjectParentType.ORGANIZATION
    ? `/library/project-templates?org=${fusaOrganization?.id}`
    : `/fusa-organizations/${fusaOrganization?.id}`;

  // Empty crumbs are dropped, so fall back to a generic label when the project is
  // linked but has not loaded - otherwise the way back to the project disappears.
  const projectTitle = project?.title || (showProjectLink ? I18n.get('project') : '');

  return (
    <Breadcrumbs items={[
      { title: fusaOrganization?.title ?? '', link: organizationLink },
      { title: workspace?.title ?? '', link: `/workspaces/${workspace?.id}` },
      { title: projectTitle, link: showProjectLink ? `/projects/${projectId}` : undefined },
      ...(trailingItems ?? []),
    ]} />
  );
}
